<template>
  <div :key="commonStore.resetKey" class="left-nav-cart-layout left-nav-layout">
    <header>
      <LeftNavHeader />
    </header>
    <aside class="left-sidebar">
      <CategorySidebar />
    </aside>
    <main><slot /></main>
    <aside class="right-sidebar">
      <LeftNavCartCart />
    </aside>
  </div>
</template>

<script lang="ts" setup>
  import CategorySidebar from '@/components/CategorySidebar.vue';
  import LeftNavHeader from '@/components/LeftNavHeader.vue';
  import LeftNavCartCart from '@/components/templates/left-nav-cart/LeftNavCartCart.vue';
  import { useCommonStore } from '@/stores/common';
  import { useConfigStore } from '@/stores/config';
  import { onBeforeMount } from 'vue';
  import { useRouter } from 'vue-router';

  const router = useRouter();
  const commonStore = useCommonStore();
  const configStore = useConfigStore();

  onBeforeMount(async () => {
    // 필수값 체크
    if (!configStore.config.StoreID || !configStore.config.SubStoreCode) {
      router.replace('/login');
      return;
    }
  });
</script>

<style lang="scss" scoped>
  @use '@/assets/scss/variables' as vars;

  .left-nav-cart-layout {
    display: grid;
    grid-template-rows: vars.$left-nav-header-height 1fr;
    grid-template-columns: vars.$left-nav-width 1fr vars.$left-nav-cart-cart-width;
    height: 100vh;
    background-color: var(--main-bg);

    header {
      grid-column: 1 / 3;
      grid-row: 1;
    }

    aside.left-sidebar {
      grid-column: 1;
      grid-row: 2;
    }

    main {
      grid-column: 2;
      grid-row: 2;
      background-color: var(--main-bg);
    }

    aside.right-sidebar {
      grid-column: 3;
      grid-row: 1 / span 2;
      border-left: 1px solid var(--sidebar-border-color);
    }
  }
</style>
